var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleCustomizeDecrement_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleCustomizeDecrement_V2";
import { handleCustomizeIncrement_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleCustomizeIncrement_V2";
import { handleRecipeDecrement_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleRecipeDecrement_V2";
import { handleRecipeIncrement_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleRecipeIncrement_V2";
import { openCustomizeModal_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/openCustomizeModal_V2";
export const handlePlusMinusClick = (adjustment, { openWhenMultipleAssignments, handleOpenCustomizeTab, isCustomizeModal, handleCustomizeIncrement, handleCustomizeDecrement, handleQuantityIncrement, handleQuantityDecrement, recipeHandlerProps_Three: RHP, assignmentCount, openCustomizeModal, setDialogContentMode, setIsDetailDialogOpen, setOpenFromIncrement, isSingleSelect, isProcessingChange, setIsProcessingChange, setIsCustomizeModalOpen, companyUsesKlaviyo, createKlaviyoEvent, datadogLog, logReactPixel, reactPixelKey, quantity, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (isProcessingChange)
        return;
    setIsProcessingChange(true);
    const handleLegacy = () => {
        if (adjustment === "add") {
            if (openWhenMultipleAssignments && handleOpenCustomizeTab)
                handleOpenCustomizeTab();
            else if (isCustomizeModal && handleCustomizeIncrement)
                handleCustomizeIncrement(quantity === 0);
            else if (!isCustomizeModal && handleQuantityIncrement)
                handleQuantityIncrement(false, false);
        }
        else if (adjustment === "sub" && quantity > 0) {
            if (openWhenMultipleAssignments && handleOpenCustomizeTab)
                handleOpenCustomizeTab();
            else if (isCustomizeModal && handleCustomizeDecrement)
                handleCustomizeDecrement();
            else if (!isCustomizeModal && handleQuantityDecrement)
                handleQuantityDecrement();
        }
        setIsProcessingChange(false);
    };
    const handleV2 = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!RHP)
            return handleLegacy();
        try {
            if (adjustment === "add") {
                if (openWhenMultipleAssignments && handleOpenCustomizeTab) {
                    handleOpenCustomizeTab();
                    return;
                }
                const shouldOpenCustomizeModal = !isCustomizeModal && quantity === 0 && !!openCustomizeModal;
                if (shouldOpenCustomizeModal) {
                    yield openCustomizeModal_V2({
                        assignmentCount: assignmentCount || 0,
                        companyUsesKlaviyo,
                        createKlaviyoEvent,
                        datadogLog,
                        isSingleSelect,
                        logReactPixel,
                        reactPixelKey,
                        recipeHandlerProps_Three: RHP,
                        setDialogContentMode,
                        setIsCustomizeModalOpen,
                        setIsDetailDialogOpen,
                        setOpenFromIncrement,
                    });
                    return;
                }
                if (isCustomizeModal)
                    yield handleCustomizeIncrement_V2(Object.assign(Object.assign({}, RHP), { shouldSetAssignmentId: quantity === 0 }));
                else
                    yield handleRecipeIncrement_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                        createKlaviyoEvent,
                        datadogLog,
                        logReactPixel,
                        reactPixelKey, createNewAssignment: false, shouldSetAssignmentId: false }));
            }
            else if (adjustment === "sub" && quantity > 0) {
                if (openWhenMultipleAssignments && handleOpenCustomizeTab) {
                    handleOpenCustomizeTab();
                    return;
                }
                if (isCustomizeModal)
                    yield handleCustomizeDecrement_V2(Object.assign({}, RHP));
                else
                    yield handleRecipeDecrement_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                        createKlaviyoEvent,
                        logReactPixel,
                        reactPixelKey }));
            }
        }
        finally {
            setIsProcessingChange(false);
        }
    });
    RHP ? yield handleV2() : handleLegacy();
});
